/* eslint-disable react/no-children-prop */
import React from "react";
import { useSelector } from "react-redux";
import { selectPaperworkData } from "store/PaperWork/selectors";
import { Column, Content, Text, Title, Wrapper } from "../styled";
import { get } from "lodash";

const DepartureObservations = ({selectedPlot}) => {
  const data = useSelector(selectPaperworkData);
  const observations = get(data, `[${selectedPlot}].domainData.departureObservations`, "-");

  return (
    <Wrapper>
      <Title children="Observaciones de partida" />
      <Content>
        <Column>
          <Text children={observations || "No hay observaciones"} />
        </Column>
      </Content>
    </Wrapper>
  );
};

export default DepartureObservations;
